import { useTranslation, Trans } from 'react-i18next';

const AboutUsPage = () => {
	const { t } = useTranslation();

	return (
		<div className="about-us">
			<img className="world-icon" src={t('WorldIconUrl')} alt="World Icon" />
			<h1 className="title">{t('AboutUs')}</h1>
			<div className="text">
				<Trans i18nKey="ArbitripAboutUs" />
			</div>
		</div>
	);
};

export default AboutUsPage;
